import request from '@/utils/request'
import qs from 'qs'

// 我的邀请
export function getInvited(query,data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/invitation/springFestival`,
    method: 'post',
    params: query,
    data,
  })
}

export function getUserInfo() {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/springFestival',
    method: 'get'
  })
}

export function registerAddress(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'post',
    data: data
  })
}


// 我的收货地址
export function getAddrInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'get',
    params: data
  })
}


// 活动中心
export function getActivity(query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/center`,
    method: 'get',
    params: query
  })
}

// 邀请注册

export function verifyPhone(query) {
  return request({
    url: `/appUser/verifyPhone`,
    method: 'post',
    data: qs.stringify(query),
    header: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8;'
    }
  })
}

export function sendMessage(query) {
  
  return request({
    url: `/szfyOfficialWebsite/v2/sendMessage`,
    method: 'post',
    params: query,
    data: query
  })
}


export function loginWithCode(query) {
  return request({
    url: `/appUser/loginByVerification`,
    method: 'post',
    params: query
  })
}


export function register(query) {
  return request({
    url: `/appUser/activity/register`,
    method: 'post',
    params: query
  })
}

export function getUser(query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/user/name`,
    method: 'get',
    params: query
  })
}

/**
 * 验证渠道id是否正确
 */
export function verifyChannelCode(query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/channel/user/name`,
    method: 'get',
    params: query
  })
}

/**
 * 渠道注册用户
 */
export function registByChannel(query) {
  return request({
    url: `/appUser/inviteChannel/register`,
    method: 'post',
    params: query
  })
}

/**
 * 拉新活动获取用户信息
 */
export function getActivityUserInfo(id,params) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/${id}`,
    method: 'post',
    // body: params || {}
    data: params || {},
    
  })
}

/**
 * 邀请用户列表
 */
export function getMyInvitionList(id, query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/invitation/${id}`,
    method: 'get',
    params: query
  })
}


/**
 * 获取邀请人的用户信息
 */
 export function getInvitationUserInfo( query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/user/info`,
    method: 'get',
    params: query
  })
}

/**
 * 组合比赛
 * 季榜
 */
 export function getMatchSeasonRank( query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/season-rank`,
    method: 'get',
    params: query
  })
}

/**
 * 组合比赛
 * 周列表
 */
 export function getMatchWeekRank( query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/week-term`,
    method: 'get',
    params: query
  })
}


/**
 * 组合比赛
 * 周列表
 */
 export function getMatchWeekList( query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/week-term/list`,
    method: 'get',
    params: query
  })
}

/**
 * 组合比赛
 * 我的排名
 */
 export function getMatchMyRank( query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/my-rank`,
    method: 'get',
    params: query
  })
}

/**
 * 组合比赛
 * 我的排名
 */
 export function getMatchInvitation( activityId) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/my/invitation-rank/${activityId}`,
    method: 'post'
  })
}

/**
 * 组合比赛
 * 我的邀请奖励
 */
 export function getMatchInvitationReward( activityId) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/my/invitation-reward/${activityId}`,
    method: 'post'
  })
}

/**
 * 组合比赛
 * 我的奖励
 */
 export function getMatchReward( activityId) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/my/reward/${activityId}`,
    method: 'post'
  })
}
// getMatchInvitationReward


// 获取已抽奖获得天数
// export function getRaffleTimes(data) {

//   return request({
//     baseURL: '/chaos/api',
//     url: '/v1/draw/my/reward',
//     method: 'post',
//     params: data
//   })
// }

// 获取已抽奖获得天数 双十一活动
export function getRaffleTimes(data) {

  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/1111',
    method: 'post',
    params: data
  })
}


// 参与抽奖
export function getDrawResult(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/draw',
    method: 'post',
    params: data
  })
}


// 用户邀请，不校验老用户
export function registerInvite(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/user/attracted`,
    method: 'post',
    data: data
  })
}





// 分享活动
export function fetchActivityShare(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/share',
    method: 'post',
    data: data
  })
}


export function activityInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity',
    method: 'get',
    params: data
  })
}






export function saveAddrInfo(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/recipient/address',
    method: 'post',
    data
  })
}



export function fetchRecipientAddress(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/recipient/address',
    method: 'get',
    params: data
  })
}


export function fetchCouponAccept(activityId) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/coupon/${activityId}/accept`,
    method: 'post',
    // params: data
  })
}


export function getSummaryData() {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/user-summary/2025`,
    method: 'post',
    // params: data
  })
}





// WEBPACK FOOTER //
// ./src/api/user-new.js